import "../assets/css/App.css";

export default function Footer() {
  return (
    <footer className="footer">
      <p>
        Contact us at:{" "}
        <a href="mailto:hello@ponopilot.com">
            hello@ponopilot.com
        </a>
      </p>
      <p>© {new Date().getFullYear()} Pono Pilot. All rights reserved.</p>
    </footer>
  );
}
